import { render } from "./addShelterDialog.vue?vue&type=template&id=044c15b6&scoped=true"
import script from "./addShelterDialog.vue?vue&type=script&lang=js"
export * from "./addShelterDialog.vue?vue&type=script&lang=js"

import "./addShelterDialog.vue?vue&type=style&index=0&id=044c15b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044c15b6"]])

export default __exports__